import * as _ from "lodash";
import {Node} from "../Node";
import {AbstractProperty} from "./AbstractProperty";
import {assertNotNull, json, MetadataRow, PropertyParameters} from "../../global";
import Commons from "oc-commons/Commons";

const transformFilenamePart = (value, fileNameTransform) => {
    const i = value.lastIndexOf('/');
    const path = value.substring(0, i);
    const filename = fileNameTransform(value.substring(i + 1));
    return (i == 0 ? path : path + '/') + filename;
}

export class AbstractUploadProperty<N extends Node> extends AbstractProperty<string, N> {

    default: string;
    contentPath: string;
    uploadPendingCounter = 0;
    version = 0;

    constructor(args: PropertyParameters) {
        super({
            default: null,
            ...args
        });
        assertNotNull('contentPath', this.name);
    }

    typeCheck(value: string): boolean {
        return _.isString(value);
    }

    set(value: string) {
        if (value!=this.node[this.name]) {
            this.incVersion();
        }
        return super.set(value);
    }

    incVersion() {
        this.version++;
        // console.log('image version', this.version);
    }

    upload(file: any) {
        this.uploadPendingCounter++;
        const root = APP.sceneNode;
        // @ts-ignore
        const path = this.contentPath.ensureRight('/');
        return APP.wkfgBackendApi.uploadContent(path, file)
            .then((filenames) => {
                const path = filenames[0];
                const url = this.toAbsoluteUrl(path);
                this.set(url);
                this.uploadPendingCounter--;
                this.incVersion();
                return path;
            })
            .catch(() => this.uploadPendingCounter--);
    }

    get uploadPending() {
        return this.uploadPendingCounter > 0;
    }

    getContentBasePath() {
        return APP.contentUrl.ensureRight('/');
    }

    toAbsoluteUrl(value) {
        if (Commons.isEmpty(value)) {
            return value;
        }
        if (/^(http|https|file):\/\/.*$/.test(value)) {
            return value;
        }
        const contentBasePath = this.getContentBasePath();
        if (!value.startsWith(contentBasePath)) {
            value = contentBasePath + value;
        }
        return transformFilenamePart(value, url => url.replace(/[ ]/g, '%20'));
    }

    toLocalPath(url) {
        if (Commons.isEmpty(url)) {
            return url;
        }
        const contentBasePath = this.getContentBasePath();
        if (url.startsWith(contentBasePath)) {
            return url.substringAfter(contentBasePath);
        }
        return transformFilenamePart(url, url => url.replace(/\%20/g, ' '));
    }

    getUriEncoded(): string {
        return this.toAbsoluteUrl(this.get());
    }

    toJSON(): json {
        return this.toLocalPath(this.get() as any);
    }

    fromJSON(json: json): this {
        this.set(this.toAbsoluteUrl(json[this.name]));
        return this;
    }

}
